var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.08 18.0395C15.02 18.0395 13.7 18.0395 13.1 18.0395C12.78 18.0395 12.68 17.9195 12.68 17.6195C12.68 16.8195 12.68 15.9995 12.68 15.1995C12.68 14.8795 12.8 14.7795 13.1 14.7795H15.08C15.08 14.7195 15.08 13.5595 15.08 13.0195C15.08 12.2195 15.22 11.4595 15.62 10.7595C16.04 10.0395 16.64 9.55953 17.4 9.27953C17.9 9.09953 18.4 9.01953 18.94 9.01953H20.9C21.18 9.01953 21.3 9.13953 21.3 9.41953V11.6995C21.3 11.9795 21.18 12.0995 20.9 12.0995C20.36 12.0995 19.82 12.0995 19.28 12.1195C18.74 12.1195 18.46 12.3795 18.46 12.9395C18.44 13.5395 18.46 14.1195 18.46 14.7395H20.78C21.1 14.7395 21.22 14.8595 21.22 15.1795V17.5995C21.22 17.9195 21.12 18.0195 20.78 18.0195C20.06 18.0195 18.52 18.0195 18.46 18.0195V24.5395C18.46 24.8795 18.36 24.9995 18 24.9995C17.16 24.9995 16.34 24.9995 15.5 24.9995C15.2 24.9995 15.08 24.8795 15.08 24.5795C15.08 22.4795 15.08 18.0995 15.08 18.0395Z",
    fill: "#4267B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f329fbbcbda586300d6eb6a2ef7fbaea.svg";
export { ForwardRef as ReactComponent };